import { JSX } from "react";

export enum PAYWALL_VARIANT {
  GALLERY = "gallery",
  ARTICLE = "article"
}

export interface Props {
  /**
   * Is the paywall for the national site
   */
  isNational: boolean;
  /**
   * Logo override for the paywall
   */
  logo?: JSX.Element;
  /**
   *  Primary site color, basis for coloring the button and bullet points
   */
  primaryColor?: string;
  /**
   * Text color for the sign up button
   */
  signInButtonColor?: string;
  /**
   * Title override for the paywall
   */
  title?: string;
  /**
   * Variant for paywall which determines styling
   */
  variant?: PAYWALL_VARIANT;
}
